export const getComponentIconSrc = (icon, white = false) => {
  const publicUrl = `${process.env.PUBLIC_URL}/img/components`
  if (!icon) return white ? `${publicUrl}/white_dummy.png` : `${publicUrl}/dummy.png`
  return white ? `${publicUrl}/white_${icon}` : `${publicUrl}/${icon}`
}
